import { startComposer } from './startComposer';

startComposer();
